"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const index_vue_1 = __importDefault(require("../comment/index.vue"));
const goodDetail_1 = require("@/api/goodDetail");
let Commend = class Commend extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
        this.allComment = [];
        this.goodsComment = [];
        this.middleComment = [];
        this.badComment = [];
        this.id = '';
    }
    // onLoad (e: any) {
    //   const el = e.path[0]
    //   ImageScale(el, 100, 100)
    // }
    getComments() {
        const req = {
            id: this.id,
            type: 0,
            status: true,
            pageNo: '1',
            pageSize: '1000',
            loginToken: this.userInfo.loginToken
        };
        goodDetail_1.commentsList(req).then(res => {
            res.forEach((item) => {
                if (item.photos) {
                    item.photosArr = item.photos.split(',');
                }
            });
            this.allComment = res;
        });
    }
    updateValue(newValue, oldValue) {
        if (newValue != oldValue) {
            this.id = newValue;
            if (this.id) {
                this.getComments();
            }
        }
    }
};
__decorate([
    vue_property_decorator_1.Prop(Object)
], Commend.prototype, "detail", void 0);
__decorate([
    vue_property_decorator_1.Prop(Array)
], Commend.prototype, "commend", void 0);
__decorate([
    vue_property_decorator_1.Watch('detail.id')
], Commend.prototype, "updateValue", null);
Commend = __decorate([
    vue_property_decorator_1.Component({
        components: { Comment: index_vue_1.default }
    })
], Commend);
exports.default = Commend;
